import api from '@/api/ks/upload.js'
const state = {
	uploadObj: {}
}
const mutations = {
}
const actions = {
	getUploaderToken({ commit },params = {}) {
		return api.getUploadToken(params)
	},
	getUploadFile({ commit }, params = {}) {
		return api.uploadFile(params)
	},
	materialAdd({}, params = {}) {
		return api.materialAdd(params)
	},
	materialIndex({}, params = {}) {
		return api.materialIndex(params)
	},
	materialRemove({}, params = {}) {
		return api.materialRemove(params)
	},
	materialEditName({}, params = {}) {
		return api.materialEditName(params)
	},
	uploadImgToWxAPI({}, params = {}) {
		return api.uploadImgToWxAPI(params)
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}